import React from "react";
import "./Footer.css";

export const Footer = () => {
  return <div className="footer">
    <div className="content">
      <div>
        Luciad NV | Hexagon
      </div>
      <div className="footer-mid">
        Gaston Geenslaan 11 | 3001 Leuven | Belgium
      </div>
      <div>
        +32 16 23 95 91 | jobs.luciad.gsp@hexagon.com
      </div>
    </div>
  </div>
}